const spanishOptionsJoyRide = {
  back: "Atrás",
  close: "Cerrar",
  last: "Finalizar",
  next: "Siguiente",
  skip: "Omitir",
};

export default spanishOptionsJoyRide;
